// src/authConfig.ts
import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "9dfe4064-8254-4cb2-96c4-c3f43968dc13",  // Your Application (Client) ID
    authority: "https://login.microsoftonline.com/445c02d3-3d3e-48cf-be87-2e6cfa4d9927",  // Azure AD Tenant ID authority
    redirectUri: window.location.origin  // redirect back to this app after login
  }
};

// Optionally, define protected resource scopes (e.g., for Graph API calls)
export const loginRequest = {
  scopes: [
    "User.Read",
    "api://e1cb820d-07a0-43d1-ba40-9fbec2d65688/access_as_user"
  ]  // example scope for reading user profile from MS Graph
};